import { sbsPartnerAPI } from "./api";

export const getSbsPartnerList = async (params) => {
  try {
    const res = await sbsPartnerAPI.getSbsPartnerList(params);
    const data = res?.data;
    const total = res?.total_count;
    return { data, total };
  } catch (e) {}
};

export const sbsPartnerTableColumns = [
  {
    name: "sbs_partner_id",
    required: true,
    label: "ID проекта",
    align: "center",
    field: "sbs_partner_id",
    sortable: true,
  },
  {
    name: "naimenovanie",
    required: true,
    label: "Наименование",
    align: "left",
    field: "naimenovanie",
    sortable: true,
  },
  {
    name: "key__ssylka",
    required: true,
    label: "key__ssylka",
    align: "left",
    field: "key__ssylka",
    sortable: true,
  },
  {
    name: "ssylka__id",
    required: true,
    label: "ssylka__id",
    align: "left",
    field: "ssylka__id",
    sortable: true,
  },
  {
    name: "direktor__view",
    required: true,
    label: "Директор",
    align: "left",
    field: "direktor__view",
    sortable: true,
  },
  {
    name: "date_modified",
    required: true,
    label: "Дата модификации",
    align: "center",
    field: "date_modified",
    sortable: true,
  },
  {
    name: "updated_at",
    required: true,
    label: "Дата обновления",
    align: "center",
    field: "updated_at",
    sortable: true,
  },
];
